export default function removeGoogleAnalysis(MEASUREMENT_ID) {
    window[`ga-disable-${MEASUREMENT_ID}`] = false;
}